// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no_link_legislation_title-module__container--FKvOt{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.no_link_legislation_title-module__iconWrapper--2BuA3{position:relative;padding-right:8px}\n", ""]);
// Exports
exports.locals = {
	"container": "no_link_legislation_title-module__container--FKvOt",
	"iconWrapper": "no_link_legislation_title-module__iconWrapper--2BuA3"
};
module.exports = exports;
